// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

export const OpenWizardButton = ({ onOpenWizard }) => {
  return (
    <>
      <Button data-cy="open-technical-policy-dialog-button" variant="contained" color="primary" onClick={onOpenWizard}>
        Configure
      </Button>
    </>
  );
};
OpenWizardButton.propTypes = {
  onOpenWizard: PropTypes.func.isRequired,
};
